import '../../resources/css/site/SiteHeader.scss';
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { doLogout } from '../../actions/login/index';
import { doSelectSiteMode } from '../../actions/site/index';
import { openModal, closeModal, UPLOAD_FILE_SUCCESS } from '../../actions/index';
import { exportSettingData } from '../../actions/site/site-data'

class SiteHeader extends Component {

  importSetting = () => {
    const { openModal } = this.props;
    openModal("importSetting", 'importSetting', null, () => {
    })
  }

  exportSetting = () => {
    const { authToken } = this.props;
    let doPost = new Promise((resolve, reject) => {
      exportSettingData(resolve, reject, authToken)
    });
    doPost
    .then((data) => {        
      if (data instanceof Blob) {
          const fileURL = window.URL.createObjectURL(data);
          let tempLink = document.createElement('a');
          tempLink.href = fileURL;
          tempLink.setAttribute('download', 'export.zip');
          tempLink.click();
      }      
    }).catch((err) => {
      console.log(err);
    });
  }

  componentDidUpdate(prevProps) {
    const { uploadInfo, status, closeModal } = this.props;
    if (JSON.stringify(prevProps.uploadInfo) !== JSON.stringify(uploadInfo) && status === UPLOAD_FILE_SUCCESS && uploadInfo.message === 'success') {
      closeModal(null);
      const { history, doLogout } = this.props;
      if (history) {
        doLogout();
        history.push(window.CONFIG.WEB_ROOT);
      }
    }
  }

  render() {
    const { doSelectSiteMode, siteMode, accountRole } = this.props;
    const clsListView = siteMode === 'list' ? 'btn-icon btn-list-view active' : 'btn-icon btn-list-view';
    const clsGridView = siteMode === 'blocks' ? 'btn-icon btn-grid-view active' : 'btn-icon btn-grid-view';
    const settings = accountRole?.flagSuperAdmin === true ? <span id="site-header-setting" className='btn-icon btn-settings' onClick={this.goToSettingsPage}></span> : <></>;

    return (
      <div className='area-site-header'>
        <div className='area-site-logo'>
          <span className='icon-sites'></span>
          <span className='logo-text'>Sites</span>
        </div>
        <div className='area-btns'>
          {/* <span className='btn-icon btn-search-n'></span> */}
          {/* <span className='btn-icon btn-import' onClick={this.importSetting}></span>
          <span className='btn-icon btn-export' onClick={this.exportSetting}></span> */}
          <span id="site-header-list-view" className={clsListView} onClick={() => doSelectSiteMode("list")}></span>
          <span id="site-header-grid-view" className={clsGridView} onClick={() => {doSelectSiteMode("blocks")}}></span>
          <span>{settings}</span>
        </div>
      </div>
    )
  }

  goToSettingsPage = () => {
    const { history } = this.props;
    history.push(window.CONFIG.WEB_ROOT + "/settings/accounts");
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authToken: state.loginReducers.authToken,
    siteMode: state.siteReducers.siteMode,
    status: state.commonReducers.status,
    uploadInfo: state.commonReducers.uploadInfo,
    accountRole: state.loginReducers.accountRole,
  }
}

export default withRouter(connect(
  mapStateToProps,
  { doSelectSiteMode, openModal, closeModal, doLogout }
)(SiteHeader))